document.addEventListener('teeinblue-event-after-cart-added', () => {
    const drawer = document.querySelector('cart-drawer');
    if (drawer) {
        fetch(window.location.pathname + "?sections=cart-drawer,cart-icon-bubble")
        .then(res => res.json())
        .then(res => drawer.renderContents({sections: res}));
        if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
    }
});

document.addEventListener('teeinblue-event-component-injected', function() {
  const elementToMove = document.querySelector('.shipping-fee');
  const insertAfterElement = document.querySelector('#teeFormActions');
  if (elementToMove && insertAfterElement) {        
    insertAfterElement.before(elementToMove);
    
  } 
});

// document.addEventListener('teeinblue-event-component-injected', function() {
//   const elementToMove = document.querySelector('.sizing-chart__button.sizing-chart__button--underline');
//   const insertAfterElement = document.querySelector('.tee-option--size .tee-row.tee-option-inner');
//   if (elementToMove && insertAfterElement) {        
//     insertAfterElement.before(elementToMove);
//     elementToMove.style.marginTop = '-10px';
//   } 
// });


(function injectCustomCSS() {
  const style = document.createElement('style');
  style.textContent = `
    .tee-option--size .tee-option__title {
      display: flex;
      justify-content: space-between;
    }
    .tee-option--size .tee-option__title .custom-trigger-button {
      display: flex;
      align-items: center;
      text-transform: none;
      cursor: pointer;
      color: #e96300;
    }
    .tee-option--size .tee-option__title .sizing-chart__button__text {
      text-decoration: underline;
      margin-left: 5px;
      font-weight: 700;
      font-size: 12px;
      text-transform: italic;
    }
    .size-chart-open .shopify-section-group-header-group {
      z-index: 1;
    }
  `;
  document.head.appendChild(style);
})();

const checkSizeChartButton = () => {
  const sizeOptionTitle = document.querySelector('.tee-option--size:not(.sr-only) .tee-option__title');
  const popupLink = document.querySelector('.sizing-chart__button');

  if (sizeOptionTitle && popupLink) {
    var existingClone = sizeOptionTitle.querySelector(".custom-trigger-button");
    if (!existingClone) {
      popupLink.style.display = 'none';
      const button = document.createElement('div');
      button.className = 'custom-trigger-button';

      button.innerHTML = popupLink.innerHTML;

      sizeOptionTitle.appendChild(button);

      button.addEventListener('click', function () {
        popupLink.click();
      });
    }
  } 
}
document.addEventListener("teeinblue-event-variant-changed", () => {
  const checkElementRendered = setInterval(() => {
    if (document.querySelector('.sizing-chart__button') && document.querySelector('.tee-option--size .tee-option__title')) {
      checkSizeChartButton();
      clearInterval(checkElementRendered);
    }
  }, 200);
});

document.addEventListener('teeinblue-event-component-injected', function() {
  const checkElementRendered = setInterval(() => {
    if (document.querySelector('.sizing-chart__button') && document.querySelector('.tee-option--size .tee-option__title')) {
      checkSizeChartButton();
      clearInterval(checkElementRendered);
    }
  }, 200);
});